var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import { addIconSVG } from "../../technical-fundamental/Icon/Icon/Icon.utils";
import { fixedForwardRef } from "../../../common/LibComponentProps";
var UnwrappedButtonLink = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var _a = props.as, Component = _a === void 0 ? "a" : _a, variant = props.variant, size = props.size, icon = props.icon, iconSvg = props.iconSvg, iconPosition = props.iconPosition, children = props.children, _b = props.disabled, disabled = _b === void 0 ? false : _b, className = props.className, style = props.style, otherProps = __rest(props, ["as", "variant", "size", "icon", "iconSvg", "iconPosition", "children", "disabled", "className", "style"]);
    var _className = classNames("fr-btn", "".concat(size ? "fr-btn--" + size : ""), "".concat(variant ? "fr-btn--" + variant : ""), "".concat(iconPosition ? "fr-btn--icon-" + iconPosition : ""), "".concat(icon ? icon : ""), className);
    var _c = addIconSVG(iconSvg, _className, style), buttonLinkClassName = _c.className, buttonLinkStyle = _c.style;
    return (React.createElement(Component, __assign({}, otherProps, { ref: ref, style: buttonLinkStyle, className: buttonLinkClassName, "aria-disabled": disabled ? true : undefined }), children));
};
var ButtonLink = fixedForwardRef(UnwrappedButtonLink);
export default ButtonLink;
